module.exports = __webpack_public_path__ + "img/icon-144x144.227371d6.png";